import { connect, Dispatch } from 'react-redux';

import { AppState } from 'src';

import { AccountViewModel } from '@models/Account';
import { CreditCardPaymentViewModel } from '@models/Payment';

import { CreditCardComponent, CreditCardComponentProperties } from './credit-card.component';

export interface CreditCardProperties {
  readonly creditCard?: AccountViewModel;
  readonly submit?: any;
  readonly buttonRef?: (button: HTMLButtonElement) => void;
  readonly saveCallback?: (creditCard: CreditCardPaymentViewModel) => void;
}

// This is used to translate the state of the page to the props on the component
function mapStateToProps(state: AppState, ownProps: CreditCardProperties): Partial<CreditCardComponentProperties> {
  return {
    buttonRef: ownProps.buttonRef,
    creditCard: ownProps.creditCard,
    isCreditCardInvalid: state.creditCards.isCreditCardInvalid,
    isError: state.creditCards.isError,
    saveCallback: ownProps.saveCallback
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(dispatch: Dispatch<AppState>): Partial<CreditCardComponentProperties> {
  return {};
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const CreditCard = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreditCardComponent);



// WEBPACK FOOTER //
// ./src/common/components/credit-cards/_components/credit-card.container.tsx